namespace SP {
    export enum ArrivalType {
        Standard = 1,
        Return = 2,
        Audit = 3,
        InternalReturn = 4
    }
}